import React, { useEffect } from 'react';

import Segmented, { SegmentedOption } from 'components/DesignSystem/Segmented';
import usePentad from 'hooks/Meteorology/Fields/ModelPerformance/usePentad';
import usePeriodType from 'hooks/Meteorology/Fields/ModelPerformance/usePeriodType';
import useOptions from 'hooks/Meteorology/Fields/ModelPerformance/useOptions';
import { store } from 'redux/store';
import { setFilter, switchPentad } from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';

import './index.scss';

/**
 * Seletor de pêntada mobile — segmented control integrado ao card "Consulta atual".
 * Substitui o bloco de pills solto do `PentadSelector` compartilhado (mantido no desktop).
 * Só troca a pêntada dentro do modo pré-definido; a troca de/para "Livre" continua no
 * Painel de controle.
 */
export default function PentadSegmented() {
  const { pentad } = usePentad();
  const { periodType } = usePeriodType();
  const { pentads } = useOptions();

  const presetPentads = pentads.filter((p) => p.id !== 'livre');
  const firstPresetPentad = presetPentads[0];
  const isFree = periodType === 'free';

  useEffect(() => {
    if (periodType !== 'preset' || !firstPresetPentad) return;
    const currentInvalid = !pentad || pentad === 'livre'
      || !presetPentads.some((p) => p.id === pentad);
    if (currentInvalid) {
      store.dispatch(setFilter({ pentad: firstPresetPentad.id }));
    }
  }, [periodType, firstPresetPentad, pentad, presetPentads]);

  useEffect(() => {
    if (periodType !== 'free') return;
    if (pentad !== 'livre') {
      store.dispatch(setFilter({ pentad: 'livre' }));
    }
  }, [periodType, pentad]);

  const handleSegmentClick = (pentadId: string) => {
    if (isFree || pentadId === pentad) return;
    // Mantém as escolhas; o usePentadRoundsSync ajusta as rodadas e replota.
    store.dispatch(switchPentad(pentadId));
  };

  const options: SegmentedOption[] = presetPentads.map((p) => ({
    value: p.id,
    label: p.label,
    disabled: isFree,
  }));

  return (
    <div className="mp-pentad-seg">
      <span className="mp-pentad-seg-label" id="mp-pentad-seg-label">Pêntada</span>
      <Segmented
        className="mp-pentad-seg-track"
        size="sm"
        ariaLabelledBy="mp-pentad-seg-label"
        options={options}
        value={isFree ? '' : (pentad ?? '')}
        onChange={handleSegmentClick}
      />
      {isFree && <span className="mp-pentad-seg-livre">Livre</span>}
    </div>
  );
}
